export default __webpack_public_path__ + "static/media/chatdesk_wordmark_dark_teal.aee7a560.svg";